import { toast } from 'react-toastify';
import get from 'lodash/get';

export const showErrors = action => {
  const errors = get(action, 'payload.errors', []);
  if (errors.length > 0) {
    toast.error(errors[0].message, { className: 'alert alert-danger' });
  }
};
